



























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import MetaDatatable from '../models/MetaDatatable';
import get from 'lodash/get';
import Program from '../models/Program';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import Datatable from '@/components/Datatable.vue';
import { BACKEND_URL } from '../helpers/constants';
import { pushDocumentsProgram, deleteDocumentProgram } from '@/api/api';
import ProgramDocument from '@/models/ProgramDocument';
import {
    documentTypes,
    formatDocumentType,
    DOCUMENT_TYPE,
} from '@/data/documentTypes';
import ProgramDocumentRequest from '@/models/ProgramDocumentRequest';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    components: {
        Datatable,
    },
    filters: {
        formatDocumentType,
    },
})
export default class DocumentsProgram extends Vue {
    loading: boolean = false;
    documentType: DOCUMENT_TYPE | null = null;
    BACKEND_URL = BACKEND_URL;
    @Prop() documents!: ProgramDocument[];
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 10,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Nom',
            dataIndex: 'document',
            scopedSlots: {
                customRender: 'name',
            },
            sorter: true,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            scopedSlots: {
                customRender: 'type',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    deleteText = {
        confirm: {
            title: `Suppression du document`,
            content: `Voulez-vous vraiment supprimer le document ?`,
        },
        notify: {
            title: 'Document supprimé',
            content: `Le document a bien été supprimé`,
        },
    };

    @Watch('documents', { deep: true })
    onDocuments() {
        // @ts-ignore
        this.$refs.datatable.refresh();
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: ProgramDocument | null;
    }) {
        const action = ev.action;
        const document = ev.item || null;
        switch (ev.action) {
            case 'edit':
                break;
            case 'delete':
                if (!document) {
                    return;
                }
                if (document && document.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                }
                await deleteDocumentProgram(
                    +this.$route.params.programID,
                    document.id
                );
                this.$emit('fetch');
                break;
        }
    }

    addDocument(type: DOCUMENT_TYPE) {
        this.documentType = type;

        // @ts-ignore
        this.$refs.fileinput.click();
    }

    async fetch(meta: MetaDatatable) {
        const page = Math.max(1, this.meta.page);
        const documents = this.documents.filter(document => {
            if (this.meta.filters && this.meta.filters.type) {
                return this.meta.filters.type === document.type;
            }
            return true;
        });
        const slice = documents.slice(
            (page - 1) * meta.perPage,
            page * meta.perPage
        );

        return {
            meta: {
                total: documents.length,
                pages: Math.ceil(documents.length / meta.perPage),
            },
            data: slice,
        };
    }

    async fileChangeListener(ev: Event) {
        const documentType = this.documentType as DOCUMENT_TYPE;
        this.documentType = null;

        const target: HTMLInputElement = ev.target as HTMLInputElement;
        const files: FileList = target.files as FileList;
        const arrayDocuments: ProgramDocumentRequest[] = [];

        if (FileReader && files && files.length) {
            for (let i = 0; i < files.length; i++) {
                (file => {
                    const name = file.name;
                    const fr = new FileReader();
                    fr.onload = async () => {
                        arrayDocuments.push({
                            file_name: name,
                            document: fr.result,
                        });

                        if (arrayDocuments.length === files.length) {
                            const $vs = (this as any).$vs;
                            try {
                                this.loading = true;
                                await pushDocumentsProgram(
                                    +this.$route.params.programID,
                                    arrayDocuments,
                                    documentType
                                );
                                this.$emit('fetch');

                                $vs.notify({
                                    color: 'success',
                                    position: 'top-right',
                                    title: 'Importation réussie',
                                    text: 'Document importé avec succès',
                                });
                            } catch (error) {
                                console.error(error);
                                $vs.notify({
                                    color: 'danger',
                                    position: 'top-right',
                                    title: "Echec de l'importation",
                                    text: "Le document n'a pas pu être importé",
                                });
                            } finally {
                                this.loading = false;
                            }
                        }
                    };
                    fr.readAsDataURL(file);
                })(files[i]);
            }
        }
    }

    deleteDialog(document: ProgramDocument) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(document),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(document: ProgramDocument) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: document });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du document`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    onFilterType(value: string | undefined) {
        if (value) {
            this.meta.filters = {
                type: value,
            };
        } else {
            this.meta.filters = null;
        }
    }

    get documentTypesArr() {
        return Object.keys(documentTypes).map(key => ({
            text: (documentTypes as any)[key],
            value: key,
        }));
    }

    filterOption(input: any, option: any) {
        return (
            option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    typeModel: string | undefined | null = null;
    created() {
        this.typeModel = undefined;
    }

    @Watch('meta', { deep: true })
    onMeta() {
        if (this.meta.filters) {
            this.typeModel = this.meta.filters.type;
        } else {
            this.typeModel = undefined;
        }
    }
}
